import { render, staticRenderFns } from "./MissingPrepaymentWarningIcon.vue?vue&type=template&id=5f5dbb1e&scoped=true"
import script from "./MissingPrepaymentWarningIcon.vue?vue&type=script&lang=js"
export * from "./MissingPrepaymentWarningIcon.vue?vue&type=script&lang=js"
import style0 from "./MissingPrepaymentWarningIcon.vue?vue&type=style&index=0&id=5f5dbb1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5dbb1e",
  null
  
)

export default component.exports